import { CiapSelectFieldModel } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { Cid11SelectFieldModel } from 'components/form/field/select/Cid11SelectField/model-cid11'
import { ProcedimentoSelectModel } from 'components/form/field/select/ProcedimentoSelectField'
import { SoapEditableItem } from 'view/atendimentos/atendimento-individual/model'

interface IntervencaoProcedimentoQueryModel {
  id: ID
  nota?: string
  ciap?: {
    id: ID
    codigo: string
    descricao: string
  }
  procedimento?: ProcedimentoSelectModel
  automatico?: boolean
}

export interface EvolucaoPlanoQueryModel {
  id: ID
  descricao?: string
  intervencoesProcedimentos?: ReadonlyArray<IntervencaoProcedimentoQueryModel>
}

export interface OrientacaoQueryModel {
  id: ID
  descricao: string
}

export interface IntervencaoPlanoItemModel extends SoapEditableItem {
  _id: ID
  observacao?: string
}

export interface CiapPlanoModel extends IntervencaoPlanoItemModel {
  ciap: CiapSelectFieldModel
}

export interface Cid11PlanoModel extends IntervencaoPlanoItemModel {
  cid11: Cid11SelectFieldModel
}

export const ALERTA_PROCEDIMENTO_INATIVO =
  'Para finalizar o atendimento, é necessário excluir o(s) procedimento(s) inativo(s).'
